/** Safe post-login return path for landing-page "Try now" links. */

import { isToolPrepKey } from "./editorEntrySession";

const STORAGE_KEY = "ls-auth-return";

/**
 * Accept only an in-app tool popup path.
 * Rejects external URLs, protocol-relative paths, and unknown tool keys.
 */
export function safeAuthReturnPath(raw) {
  if (typeof raw !== "string") return null;
  const trimmed = raw.trim();
  if (!trimmed.startsWith("/") || trimmed.startsWith("//") || trimmed.includes("\\")) {
    return null;
  }
  const path = trimmed.split(/[?#]/)[0];
  const match = path.match(/^\/tools\/([a-z0-9_]+)\/?$/);
  if (!match || !isToolPrepKey(match[1])) return null;
  return `/tools/${match[1]}`;
}

export function rememberAuthReturnPath(path) {
  const safe = safeAuthReturnPath(path);
  if (!safe) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, safe);
  } catch {
    // ignore quota / private mode
  }
}

export function peekAuthReturnPath() {
  try {
    return safeAuthReturnPath(sessionStorage.getItem(STORAGE_KEY) || "");
  } catch {
    return null;
  }
}

export function clearAuthReturnPath() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Query `redirect` wins; sessionStorage covers Clerk dropping the query. */
export function resolveAuthReturnPath(search = "") {
  const params = new URLSearchParams(typeof search === "string" ? search : "");
  return safeAuthReturnPath(params.get("redirect") || "") || peekAuthReturnPath();
}

const PENDING_TOOL_KEY = "ls-pending-tool-popup";

/** Remember a tool popup across the welcome-credits step and a refresh. */
export function rememberPendingToolPopup(toolKey) {
  if (!isToolPrepKey(toolKey)) return;
  try {
    sessionStorage.setItem(PENDING_TOOL_KEY, toolKey);
  } catch {
    // ignore
  }
}

export function consumePendingToolPopup() {
  try {
    const key = sessionStorage.getItem(PENDING_TOOL_KEY) || "";
    sessionStorage.removeItem(PENDING_TOOL_KEY);
    return isToolPrepKey(key) ? key : null;
  } catch {
    return null;
  }
}
